import { useSceneEntities } from "@/stores/SceneEntities";
export function useAssetTub3053Door(payload, viewport) {
  const sceneEntities = useSceneEntities();  

  viewport.invalidateTransformForKey("elite_3053_tub_door","elite_3053_tub_door_open");
}
